<template>
  <div>
    <vue-element-loading
      is-full-screen
      :active="loading"
      spinner="bar-fade-scale"
      color="#152d51"
    />
    <div class="navbar nav-regis w-100" style="background-color: #23409a; color: white">
      <h3 class="w-100 text-center my-3">ข้อกำหนดและเงื่อนไข</h3>
    </div>
    <div
      class="bg-gray p-3 p-sm-4 w-100"
      :style="
        `height: calc(100vh - 158); overflow: auto; margin-top: 60px; padding-bottom: 110px !important;`
      "
    >
      <div class="mt-5" v-html="htmlData.htmlBody"></div>
      <v-checkbox
        v-if="!read"
        style="color: #23409a !important"
        class="mt-3"
        v-model="checkbox"
        label="ข้าพเจ้ายอมรับข้อกำหนดและเงื่อนไขการให้บริการ"
      ></v-checkbox>
    </div>
    <div
      v-if="!read"
      :class="`w-100 ${back ? 'bot-regis-2' : 'bot-regis'} p-2 flex-all-center flex-wrap`"
    >
      <v-btn
        @click="summitTC"
        :disabled="!checkbox"
        class="col-8 main-btn"
        style="color: white"
        color="#23409A"
        >ยอมรับเงื่อนไข</v-btn
      >
      <v-btn v-if="back" @click="$emit('back')" class="col-8 main-btn" color="#f5f5f5"
        >ย้อนกลับ</v-btn
      >
    </div>
  </div>
</template>

<script>
import consendApi from '@/api/consend'
import config from '@/config'
import VueElementLoading from 'vue-element-loading'
import { mapGetters } from 'vuex'

export default {
  props: {
    read: {
      default: false
    },
    back: {
      default: true
    },
    fetchApi: {
      default: true
    }
  },
  components: { VueElementLoading },
  data() {
    return {
      loading: false,
      checkbox: false,
      htmlData: ''
    }
  },
  async mounted() {
    const configApi = {
      params: {
        company: 'NCAP',
        product: 'HP-MC',
        template_id: 'Consent_TC',
        page_id: config.pageid
      }
    }
    try {
      this.loading = true
      const response = await consendApi.getConsendTemplateV2(configApi)
      this.htmlData = response.data.data
    } catch (error) {
      console.error(error)
      this.$swal.fire({
        type: 'error',
        text: 'โหลดข้อกำหนดและเงื่อนไขไม่สำเร็จ'
      })
    } finally {
      this.loading = false
    }
  },
  methods: {
    async summitTC() {
      if (!this.htmlData || !this.htmlData.version) {
        this.$swal.fire({
          type: 'error',
          text: 'เกิดข้อผิดพลาดไม่พบ version pdpa'
        })
        return
      }
      if (!this.profile || !this.profile.displayName || !this.profile.userId) {
        this.$swal.fire({
          type: 'error',
          text: 'เกิดข้อผิดพลาดไม่พบข้อมูลผู้ใช้'
        })
        return
      }
      if (!this.fetchApi) {
        let tempData = this.regisList
        tempData.version.tc = this.htmlData.version
        tempData.answer.tc = 'Y'
        this.$store.dispatch('setRegisList', tempData)
        this.$emit('next')
        return
      }
      try {
        this.loading = true
        await consendApi.postUserConsendV2({
          body: {
            page_id: config.pageid,
            next_body: [
              {
                ConsentType: 'Consent_TC_NextConnect',
                lineName: this.profile.displayName,
                userId: this.profile.userId,
                version: this.htmlData.version,
                companyKey: 'NCAP',
                ConsentItemId: 'T&C_HPMC',
                answer: 'Y'
              }
            ]
          },
          config: {}
        })
        this.$emit('next')
      } catch (error) {
        this.$swal.fire({
          type: 'error',
          text: 'เกิดข้อผิดพลาด'
        })
      } finally {
        this.loading = false
      }
    }
  },
  computed: {
    ...mapGetters(['regisList']),
    query() {
      return this.$store.state.query
    },
    view() {
      return this.$store.state.query.view
    },
    profile() {
      return this.$store.state.profile
    },
    userId() {
      return this.$store.getters.getUserid
    }
  }
}
</script>

<style>
.slidedealer,
.slidedealer-back {
  &-enter-active,
  &-leave-active {
    position: absolute;
    width: 100%;
    background: white;
    min-height: 100vh;
    top: 12px;
  }
}
// router view
.slidedealer-enter-active {
  transition: transform $duration ease-in-out;
  z-index: 2;
  transform: translateX(100%);
}
.slidedealer-enter-to {
  z-index: 2;
  transform: translateX(0%);
}
.slidedealer-leave-active {
  z-index: -1;
}
.slidedealer-leave-to {
  z-index: -1;
}
// router view back

.slidedealer-back-enter-active {
  z-index: -1;
}
.slidedealer-back-enter-to {
  z-index: -1;
}

.slidedealer-back-leave-active {
  transition: transform $duration ease-in-out;
  z-index: 2;
  transform: translateX(0%);
}
.slidedealer-back-leave-to {
  transform: translateX(100%);
  z-index: 2;
}
.addcartbtn {
  position: fixed;
  text-align: center;
  padding-top: 15px;
  z-index: 1;
  font-size: 23px;
  bottom: 0px;
  background-color: rgb(12, 77, 157);
  width: 90vw;
  height: 60px;
  color: white;
  border-radius: 13px 13px 0px 0px;
  left: 50%;
  transform: translate(-50%, 0);
}
.myshadow {
  -webkit-box-shadow: 2px 3px 17px -1px rgba(0, 0, 0, 0.75);
  -moz-box-shadow: 2px 3px 17px -1px rgba(0, 0, 0, 0.65);
  box-shadow: 2px 3px 17px -1px rgba(0, 0, 0, 0.95);
}
.center {
  display: flex;
  align-items: center;
  justify-content: center;
}
/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type='number'] {
  -moz-appearance: textfield;
}
</style>
